import Swiper from "swiper";
import { breakpoints } from "../../variables.json";

var galleryThumbs = new Swiper(".js-timeline .js-pagination", {
	slidesPerView: "auto",
	watchSlidesVisibility: true,
	wrapperClass: "timeline__pagination"
});

new Swiper(".js-timeline .js-container", {
	speed: 1000,
	spaceBetween: 20,
	slidesPerView: 1,
	wrapperClass: "timeline__list-wrapper",
	navigation: {
		prevEl: ".js-timeline .js-prev",
		nextEl: ".js-timeline .js-next",
		disabledClass: "timeline__control--disabled"
	},
	breakpointsInverse: true,
	breakpoints: {
		[parseInt(breakpoints.medium)]: {
			slidesPerView: "auto"
		}
	},
	thumbs: {
		swiper: galleryThumbs,
		slideThumbActiveClass: "is-active",
		multipleActiveThumbs: false
	}
});
